export default "__VITE_ASSET__CDzMEvSd__"